import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "mdbreact/dist/css/mdb.css";
import { MDBCard, MDBCardBody, MDBCardTitle } from "mdbreact";

import Slider from "./Slider";
import HomeCardDeck from "./HomeCardDeck";
//import colors from "../../colors";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: true,
    };
  }
 
  render() {
    return (
      <div
      className="cardeck_full"
      
    >
      <div
      className="carddeck_inner"
        style={{
          // paddingTop: "0px",
          // paddingRight: "10px",
          // paddingBottom: "10px",
          // paddingLeft: "10px",
          backgroundColor: "#f0f5ff",
        }}
      >
      
          <Slider />
          <HomeCardDeck />
          <div style={{ padding: "10px" }}>
            <MDBCard style={{ width: "100%", textAlign: "jusitfy" }}>
              <MDBCardBody>
                <MDBCardTitle style={{ color: "blue" }}>
                  Experimental Hydrological Fluxes using Land Surface Model
                </MDBCardTitle>
                {/* <h5>More Information</h5> */}
                {/* <MDBCardText style={{align:"justify"}}> */}
                Description of terrestrial hydrological flux components in terms
                of their geographical distribution and chronological variation
                is useful for water resources management, drought/flood
                assessment and climate related research. Earth Observation (EO)
                data from multitude platforms are providing wide ranging
                datasets that are useful for creation of spatially distributed
                parameters appropriate for hydrological budgeting and modeling.
                Macro-scale, process based hydrological (Variable Infiltration
                Capacity - VIC) model has been adopted for modelling water
                balance components at uniform grid level. VIC, a
                semi-distributed & physically based hydrological model, solves
                both the water balance and the energy balance (Liang X., 1994).
                Model computes evapotranspiration, surface runoff, soil
                moisture, base flow and energy fluxes at the predefined grid
                resolution (few km to hundred km).
                {/* </p>
                        </MDBCardText> */}
              </MDBCardBody>
            </MDBCard>
          </div>
        </div>
      </div>
    );
  }
}

export default Home;
